<template>
  <div>
    <template-chart :items="myItems" :yyyy="yyyy"></template-chart>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['item', 'yyyy', 'mm', 'value', 'group', 'prev', 'plan'],
  computed: {
    ...mapGetters({
      windowSize: 'shared/windowSize'
    }),
    headers () {
      var temp = []
      temp.push({ title: '在籍合計', key: 17, align: 'start', calc: 'ave' })
      if (this.item.schools.preschool) {
        if (this.item.schools.extension === 1) {
          temp.push({ title: '幼児在籍', key: 30, align: 'start', calc: 'ave' })
        } else {
          temp.push({ title: '幼児在籍', key: 0, align: 'start', calc: 'ave' })
        }
      }
      temp.push({ title: '小学部在籍', key: 14, align: 'end', calc: 'ave' })

      temp.push({ title: '中学部在籍', key: 15, align: 'end', calc: 'ave' })

      temp.push({ title: '高校部在籍', key: 16, align: 'end', calc: 'ave' })

      return temp
    },
    myItems () {
      var temp = []
      var acts = []
      for (var i in this.headers) {
        var values = this.item['calc_acts'][this.yyyy][this.group].map(v => {
          return v[this.headers[i].key]
        })
        acts.push({
          'key': this.headers[i].key,
          'title': this.headers[i].title,
          'align': 'start',
          'values': values,
          'sum': this.item['calc_acts_sum'][this.yyyy][this.group][2][this.headers[i].key],
          'prefix': '',
          'suffix': '',
          'color': '#BBDEFB80',
          'calc': 'ave'
        })
      }
      var prevs = []
      if (this.prev) {
        var prev = this.yyyy - 1
        var id = this.value ? 'calc_acts_diff' : 'calc_acts'
        if (prev >= 2018) {
          for (i in acts) {
            values = this.item[id][prev][this.group].map((v) => {
              return v[acts[i].key]
            })

            prevs.push({
              'key': 'prev' + id + prev + acts[i].key,
              'title': this.value ? '昨年' : '昨年',
              'align': 'end',
              'values': values,
              'sum': this.item[id + '_sum'][prev][this.group][2][this.headers[i].key],
              'prefix': '',
              'suffix': this.value ? '%' : '',
              'color': '',
              'calc': ''
            })
          }
        }
      }
      var plans = []
      if (this.plan) {
        id = this.value ? 'calc_acts_plans_diff' : 'calc_plans_students'
        for (i in acts) {
          values = this.item[id][this.yyyy][this.group].map((v) => {
            return v[acts[i].key]
          })

          plans.push({
            'key': 'plans' + id + acts[i].key,
            'title': this.value ? '目標' : '目標',
            'align': 'end',
            'values': values,
            'sum': this.item[id + '_sum'][this.yyyy][this.group][2][this.headers[i].key],
            'prefix': '',
            'suffix': this.value ? '%' : '',
            'color': '',
            'calc': ''
          })
        }
      }
      for (i in acts) {
        temp.push(acts[i])
        if (prevs.length !== 0) {
          temp.push(prevs[i])
        }
        if (plans.length !== 0) {
          temp.push(plans[i])
        }
      }
      return temp
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
